import { Map } from "@/shared/components/control";
import { Section } from "@/shared/components/ui";
import { useTranslation } from "react-i18next";

export function Lore() {
  const { t } = useTranslation();
  const paragraphs = t("home.lore.paragraphs", { returnObjects: true }) as string[];
  return (
    <Section
      narrow
      className="border-b border-border-soft bg-surface-1/25 overflow-hidden"
    >
      <div className="relative">
        <div
          className="pointer-events-none absolute -left-[min(18vw,7rem)] -top-32 h-[26rem] w-[min(88vw,26rem)] rounded-[50%] bg-[radial-gradient(circle_at_30%_30%,rgb(201_167_232/0.11),transparent_62%)] blur-2xl"
          aria-hidden
        />
        <div className="pointer-events-none absolute left-1/2 top-1/2 h-[120%] w-[min(100%,42rem)] -translate-x-1/2 -translate-y-1/2 bg-[radial-gradient(ellipse_70%_50%_at_50%_50%,rgb(21_9_38/0.65),transparent_70%)]"
          aria-hidden
        />

        <div className="relative flex gap-7 sm:gap-10 lg:gap-14">
          <div
            className="relative hidden w-[3px] shrink-0 rounded-full bg-gradient-to-b from-accent via-accent/35 to-transparent sm:block sm:min-h-[16rem] self-stretch"
            aria-hidden
          >
            <span className="absolute left-1/2 top-0 h-2 w-2 -translate-x-1/2 rounded-full bg-accent/90 shadow-[0_0_20px_rgb(201_167_232/0.45)]" />
          </div>

          <div className="min-w-0 flex-1 space-y-10 sm:space-y-12">
            <header className="space-y-6">
              <h2
                className="mii-lore-rise font-display text-[calc(1.9rem+1.15vw)] font-semibold leading-[1.1] tracking-tight text-balance text-ink"
                style={{ animationDelay: "30ms" }}
              >
                {t("home.lore.title")}
              </h2>
              <div
                className="mii-lore-rise flex flex-wrap items-center gap-4"
                style={{ animationDelay: "90ms" }}
              >
                <span
                  className="h-px w-14 shrink-0 bg-gradient-to-r from-accent to-transparent sm:w-20"
                  aria-hidden
                />
                <span className="font-mono text-[0.6rem] uppercase tracking-[0.28em] text-ink-muted">
                  {t("home.lore.kicker")}
                </span>
              </div>
            </header>

            <div className="space-y-8 sm:space-y-10">
              <Map
                items={paragraphs}
                keyExtractor={(p, i) => `lore-${i}`}
                render={(p, i) => (
                  <p
                    className={
                      i === 0
                        ? "mii-lore-rise text-pretty whitespace-pre-line text-[calc(1.06rem+0.22vw)] font-normal leading-[1.65] text-ink-secondary sm:text-[calc(1.1rem+0.2vw)]"
                        : "mii-lore-rise text-pretty whitespace-pre-line border-l border-accent/22 pl-5 text-[calc(0.92rem+0.1vw)] font-normal leading-relaxed text-ink-secondary/92 sm:pl-7 sm:text-[calc(0.95rem+0.12vw)]"
                    }
                    style={{ animationDelay: `${140 + i * 95}ms` }}
                  >
                    {p}
                  </p>
                )}
              />
            </div>
          </div>
        </div>
      </div>
    </Section>
  );
}
